/** @format */

// 商户类型：01普通商户 02酒店商户 03中央服务台
export enum BusinessType {
  Normal = '01',
  Hotle = '02',
  Center = '03'
}

export const businessTypeMap: {
  [key: string]: string;
} = {
  [BusinessType.Normal]: '普通商户',
  [BusinessType.Hotle]: '酒店商户',
  [BusinessType.Center]: '中央服务台'
};
//优惠券类型 01 时长 02金额 03 全免 04折扣 05时段
export enum CouponType {
  Time = '01',
  Price = '02',
  allFree = '03',
  Discount = '04',
  Term = '05'
}

export const couponTypeMap: {
  [key: string]: string;
} = {
  [CouponType.Price]: '金额',
  [CouponType.Time]: '时长',
  [CouponType.allFree]: '全免',
  [CouponType.Discount]: '折扣',
  [CouponType.Term]: '时段'
};
//下发状态 02下发中，01下发成功，00下发失败
export enum SendStatus {
  Success = '01',
  Sending = '02',
  Failure = '00'
}

export const sendStatusMap: {
  [key: string]: string;
} = {
  [SendStatus.Success]: '下发成功',
  [SendStatus.Sending]: '下发中',
  [SendStatus.Failure]: '下发失败'
};
//优惠券状态 00禁用  01启用   02失效
export enum CouponStatus {
  Forbiden = '00',
  Using = '01',
  Failure = '02',
  toUse = '03'
}

export const couponStatusMap: {
  [key: string]: string;
} = {
  [CouponStatus.Forbiden]: '已禁用',
  [CouponStatus.Using]: '已生效',
  [CouponStatus.Failure]: '已过期',
  [CouponStatus.toUse]: '待生效'
};
//发券方式 00商家发放  01扫码领券静态   02扫码领券动态 03扫码领券打印
export enum sendCoupon {
  FromMerchant = '00',
  SacnDong = '01',
  ScanJing = '02',
  ScanPrint = '03'
}

export const sendCouponMap: {
  [key: string]: string;
} = {
  [sendCoupon.FromMerchant]: '商家发放',
  [sendCoupon.SacnDong]: '扫码领券(静态)',
  [sendCoupon.ScanJing]: '扫码领券(动态)',
  [sendCoupon.ScanPrint]: '扫码领券(打印)'
};
//优惠来源 00账户余额  01固定面额
export enum couponFrom {
  account = '01',
  fixed = '00'
}

export const couponFromMap: {
  [key: string]: string;
} = {
  [couponFrom.account]: '账户余额',
  [couponFrom.fixed]: '固定面额'
};
// 01增值税普通发票  02增值税专用发票
export enum InvoiceType {
  Using = '01',
  Failure = '02'
}

export const invoiceTypeMap: {
  [key: string]: string;
} = {
  [InvoiceType.Using]: '增值税普通发票',
  [InvoiceType.Failure]: '增值税专用发票'
};
